import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const WealthManagementAPI = (props) => {
 
  return axios.get(
    `${env.HOST}/solusi-masa-depan-anda/wealth${props}`,
    {
      headers
    }
  );
};
export default WealthManagementAPI;
